import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useSetRealityCheck = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetRealityCheckRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetRealityCheckRequestData, TServerSendResponse>({
            ID: 89915,
            responses: [89916, 89900],
            description: 'Set Player Reality Check',
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`),
            ...request
        });

        return data;
    }, [
        send
    ]);
};
